module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('a', {
    attrs: {
      "href": "#/Untitled118"
    }
  }, [_vm._v("TO GERALD DUCKWORTH")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('a', {
    attrs: {
      "href": "#/Untitled119"
    }
  }, [_vm._v("PART I")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-"
  }, [_c('a', {
    attrs: {
      "href": "#/Untitled120"
    }
  }, [_vm._v("CHAPTER I")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-"
  }, [_c('a', {
    attrs: {
      "href": "#/Untitled121"
    }
  }, [_vm._v("CHAPTER II")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-"
  }, [_c('span', {
    attrs: {
      "href": "#/Untitled122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER III")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    attrs: {
      "href": "#/Untitled123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART II")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-"
  }, [_c('span', {
    attrs: {
      "href": "#/Untitled124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER I")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-"
  }, [_c('span', {
    attrs: {
      "href": "#/Untitled125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER II")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-"
  }, [_c('span', {
    attrs: {
      "href": "#/Untitled126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER III")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-"
  }, [_c('span', {
    attrs: {
      "href": "#/Untitled127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER IV")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-"
  }, [_c('span', {
    attrs: {
      "href": "#/Untitled128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER V")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-"
  }, [_c('span', {
    attrs: {
      "href": "#/Untitled129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER VI")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    attrs: {
      "href": "#/Untitled130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART III")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-"
  }, [_c('span', {
    attrs: {
      "href": "#/Untitled131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER I")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- _idGenParaOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Untitled132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER II")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79f7e020","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Untitled117.vue
// module id = 66
// module chunks = 0